module.exports = __webpack_public_path__ + "assets/img/card_deauville2020.b936e9f7.png";